import React from 'react';

import { RadioInput} from '@sogei/react-web-components-catalog'
import i18next from 'i18next';
import { inject, observer } from 'mobx-react';
import { Input, InputFile, SingleSwitch, Card  } from '@sogei/react-web-components-catalog'




@inject("rootStore")
@observer
class ProfiloSelezionato extends React.Component {

  constructor(props) {
    super(props);
    this.qualificheStore = props.rootStore.qualificheStore;
  
  }

  componentDidMount() {
  }

 

  render() {
    console.log(JSON.stringify(this.qualificheStore.qualifica))
    if(!this.qualificheStore.qualifica || this.qualificheStore.tipoPratica === 'CP'){
      return <></>
    }

let testo = ""
switch (this.qualificheStore.tipoPratica) {
  case "CI":
    testo = (
      <>
        <b>{i18next.t("PER_CONTO_DELL_ENTE")}{" "}</b>
        {this.qualificheStore.qualifica?.denominazioneUtenza}
      </>
    );
    break;

  default:
    testo = (
      <>
        <span className="text-muted">{i18next.t("PROFILO_ATTIVO")}{" "}</span>
        {this.qualificheStore.qualifica?.denominazioneUtenza}{" "}
        {this.qualificheStore.codiceFiscaleRiferimento() && (
          <>
           -          
            {this.qualificheStore.codiceFiscaleRiferimento()}
         
          </>
        )}
      </>
    );
    break;
}

    

      //console.log("props: ", JSON.stringify(props));
      return (
        
          <div className='row pt-2'>
              <div className='col'>
             
              <div class="card card-default">
                
                <div class="card-body">
                  {testo}
                </div>
                
              </div>
              </div>
          </div>
   
      )
    }

  }


export {ProfiloSelezionato } ;